import { render, staticRenderFns } from "./QuotazioneForm.vue?vue&type=template&id=3d4c08a3"
import script from "./QuotazioneForm.vue?vue&type=script&lang=js"
export * from "./QuotazioneForm.vue?vue&type=script&lang=js"
import style0 from "./QuotazioneForm.vue?vue&type=style&index=0&id=3d4c08a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports